"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aitoSchemaToColumns = void 0;
function aitoSchemaToColumns(tableSchema) {
    const result = [];
    const columnNames = Object.keys(tableSchema.columns);
    for (const column of columnNames) {
        const columnSchema = tableSchema.columns[column];
        switch (columnSchema.type) {
            case 'Boolean':
                result.push({
                    name: column,
                    variable: 'categorical',
                    element: 'scalar',
                    data: 'boolean',
                });
                break;
            case 'Int':
                result.push({
                    name: column,
                    variable: 'numerical',
                    element: 'scalar',
                    data: 'int',
                });
                break;
            case 'Long':
                result.push({
                    name: column,
                    variable: 'numerical',
                    element: 'scalar',
                    data: 'long',
                });
                break;
            case 'Decimal':
                result.push({
                    name: column,
                    variable: 'numerical',
                    element: 'scalar',
                    data: 'decimal',
                });
                break;
            case 'String':
                result.push({
                    name: column,
                    variable: 'categorical',
                    element: 'scalar',
                    data: 'string',
                });
                break;
            case 'Text':
                result.push({
                    name: column,
                    variable: 'categorical',
                    element: 'vector',
                    data: 'text',
                });
                break;
        }
    }
    return result;
}
exports.aitoSchemaToColumns = aitoSchemaToColumns;
//# sourceMappingURL=datasets.js.map